import SectionList from './styled';

export default SectionList;
